






























































import { PlayErrorField } from '@empathybroker/tsclient-play/dist/models/play-error-field';
import { PlayErrorReason } from '@empathybroker/tsclient-play/dist/models/play-error-reason';

import { mapGetters } from 'vuex';

import { FilterTypeEnum } from '../../enums';

import { Filter, RegularFilter } from '../../models';

import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import Badge from '../badge.component.vue';
import { UiAlert, UiButton, UiIcon } from '../keen-ui';
import EnabledField from './enabled-field.component.vue';
import Schedule from './schedule.component.vue';

export default {
  name: 'crud-form',
  components: {
    UiAlert,
    Badge,
    UiIcon,
    EnabledField,
    Schedule,
    UiButton
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    })
  },
  data: function () {
    return {
      showErrorContainer: false
    };
  },
  props: {
    item: Object,
    enabledFieldConfig: Object,
    includeScheduleFields: Boolean,
    sectionTitlesHidden: Boolean,
    acceptActionDisabled: Boolean,
    errorsFields: Array,
    messages: Object
  },
  methods: {
    getErrorFieldHeaderText: function (errorField: PlayErrorField): string {
      let headerText: string;
      let fieldId;
      if (!Array.isArray(errorField.fieldId)) {
        fieldId = errorField.fieldId.split('.').pop();
      } else {
        fieldId = (errorField.fieldId as string[]).map(field => {
          const fieldMessage = this.messages.fields[field.split('.').pop()];
          return ((!!fieldMessage && fieldMessage.label) || field);
        }).join(', ');
      }
      const fieldMessages = this.messages.fields[fieldId];
      if (!!fieldMessages) {
        headerText = fieldMessages.label;
      } else {
        const fieldFilter = (Object.values(this.context.filters)
          .find((filter: Filter) => ((filter.config.type === FilterTypeEnum.REGULAR) &&
            (((filter as RegularFilter).config.toolingId || filter.config.id) === fieldId))) as RegularFilter);
        if (!!fieldFilter) {
          const filtersNames = this.$epb.messages.filters.names;
          headerText = (fieldFilter.config.prettyName || filtersNames[fieldFilter.config.id] || fieldFilter.config.id);
        }
      }
      return (headerText || fieldId);
    },
    getErrorFieldReasonMessage: function (reason: PlayErrorReason, errorField: PlayErrorField): string {
      let reasonMessage: string;
      let fieldId: string;
      if (!Array.isArray(errorField.fieldId)) {
        fieldId = errorField.fieldId.split('.').pop();
      } else {
        fieldId = (errorField.fieldId as string[]).map(field => field.split('.').pop()).join(', ');
      }
      const fieldMessages = this.messages.fields[fieldId];
      if (!!fieldMessages && !!fieldMessages.errors) {
        reasonMessage = fieldMessages.errors[reason.id];
      }
      return (reasonMessage || this.$epb.messages.errors[400].reasons[reason.id] || reason.message);
    }
  },
  watch: {
    errorsFields: {
      handler: function (errorsFields: any[]): void {
        this.showErrorContainer = !!errorsFields.length;
        if (this.showErrorContainer) {
          this.$emit('resetScroll');
        }
      },
      immediate: true
    }
  }
};

